<template>
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="首页2.0" transform="translate(-1876.000000, -690.000000)">
        <g id="申请试用备份-8" transform="translate(1856.000000, 686.000000)">
          <g id="编组-21" transform="translate(20.000000, 4.000000)">
            <rect id="矩形" fill="#D8D8D8" opacity="0" x="0" y="0" width="24" height="24"></rect>
            <g id="a-hetong1" transform="translate(4.440356, 2.677770)" :fill="color" fill-rule="nonzero">
              <path
                id="路径"
                d="M13.9974919,0.1631099 L10.0096215,4.15098037 L9.72667571,5.58568168 L11.161377,5.30273594 L15.0560418,1.40807112 C14.9111096,0.853579459 14.5214637,0.39531666 13.9974919,0.1631099 L13.9974919,0.1631099 Z"
              ></path>
              <path
                id="形状"
                d="M11.9802553,6.41454624 C11.8837208,6.51108066 11.763885,6.57432736 11.6307341,6.60095754 L8.99101681,7.12357496 C8.76747184,7.16861514 8.53623217,7.09861827 8.37519373,6.93716366 C8.21541261,6.77738254 8.14217959,6.5443684 8.18878243,6.32134058 L8.71139985,3.68162333 C8.73803003,3.54847239 8.80127673,3.42863655 8.89781115,3.33210213 L12.2265845,0 L1.36812584,0 C0.612530805,0 0,0.612530805 0,1.36812584 L0,17.2763337 C0,18.0319287 0.612530805,18.6444595 1.36812584,18.6444595 L13.7511627,18.6444595 C14.5067577,18.6444595 15.1192885,18.0319287 15.1192885,17.2763337 L15.1192885,3.27551297 L11.9802553,6.41454624 Z M2.55649793,8.97770171 L9.49033281,8.97770171 C9.86648419,8.97770171 10.1727313,9.28394885 10.1727313,9.66010025 C10.1727313,10.0362517 9.86648419,10.3424988 9.49033281,10.3424988 L2.55649793,10.3424988 C2.18034655,10.3424988 1.87409939,10.0362517 1.87409939,9.66010025 C1.87409939,9.28394885 2.18034653,8.97770171 2.55649793,8.97770171 Z M11.1946648,13.5514445 L2.55649793,13.5514445 C2.18034655,13.5514445 1.87409939,13.2451891 1.87409939,12.8690378 C1.87409939,12.4928864 2.18034653,12.1866392 2.55649793,12.1866392 L11.1946648,12.1866392 C11.5708161,12.1866392 11.8770715,12.4928864 11.8770715,12.8690378 C11.877954,13.0502927 11.8063447,13.2243814 11.6781766,13.3525496 C11.5500084,13.4807177 11.3759197,13.552327 11.1946648,13.5514445 Z"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  components: {},
  props: {
    color: String,
  },
  data() {
    return {}
  },

  mounted() {},

  methods: {},
}
</script>

<style lang="less" scoped></style>
